import Link from "next/link";
import HubSpotForm from "./HubSpotForm";
import { contact, footerQuickLinks, footerTreatments } from "@/lib/site";
import { useI18n } from "./I18nContext";

// footer.php. The commented-out newsletter block and the Mailchimp/ajaxChimp
// wiring in custom.js were dead on the live site and are not carried over.

function FooterLinks({ heading, items }: { heading: string; items: { label: string; href?: string }[] }) {
  const { t, localizeHref } = useI18n();
  return (
    <div className="footer-item">
      <div className="footer-quick">
        <h3>{t(heading)}</h3>
        <ul>
          {items.map((item) => (
            <li key={item.label}>
              <Link href={localizeHref(item.href!)}>{t(item.label)}</Link>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default function Footer() {
  const { t } = useI18n();
  return (
    <>
      <footer className="pb-70">
        <div className="container">
          <div className="row">
            <div className="col-sm-6 col-lg-4">
              <div className="footer-item">
                <div className="footer-contact">
                  <h3>{t("Contact Us")}</h3>
                  <ul>
                    <li>
                      <i className="icofont-ui-message" />
                      <a href={`mailto:${contact.email}`}>Email:{contact.email}</a>
                    </li>
                    <li>
                      <i className="icofont-stock-mobile" />
                      <a href={contact.phoneHref}>Call: {contact.phone}</a>
                    </li>
                    <li>
                      <i className="icofont-location-pin" />
                      {t(contact.address)}
                    </li>
                    <li>
                      <i className="icofont-ui-timer" />
                      {t(contact.hours)}
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="col-sm-6 col-lg-2">
              <FooterLinks heading="Quick Links" items={footerQuickLinks} />
            </div>

            <div className="col-sm-6 col-lg-3">
              <FooterLinks heading="Our Treatments" items={footerTreatments} />
            </div>

            <div className="col-sm-6 col-lg-3">
              <div className="footer-item">
                <div className="footer-feedback">
                  <h3>{t("Feedback")}</h3>
                  <HubSpotForm />
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <div className="copyright-area">
        <div className="row copyright-item w-100">
          <div className="col-sm">
            <p>Copyright {new Date().getFullYear()} © Dr .Parveen Yadav all rights reserved.</p>
          </div>
          <div className="col-sm">
            <p>
              Proudly Scaled by{" "}
              <a href="https://publicmediasolution.com/" target="_blank" rel="noopener noreferrer">
                Public Media Solution!
              </a>
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
